import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      topReviews: state => state.reviews.topReviews,
    }),
  },
  created () {
    this.$store.dispatch('reviews/topReviews')
  }
}
